<!--
/**
 * DjActivationTab.vue - 限制返档 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的限制返档管理页面，
 * 用于限制或取消限制号码的激活（返档）操作。限制激活后该号码无法被重新激活，
 * 取消限制后恢复激活能力。支持手动输入和文件批量上传两种模式。
 *
 * 【主要功能】
 * 1. 返档记录查询 - 按号码、订单编号、充值类型、状态等条件查询
 * 2. 限制激活 - 限制指定号码的激活能力
 * 3. 取消限制激活 - 恢复指定号码的激活能力
 * 4. 文件批量操作 - 通过上传txt文件批量执行限制/取消限制
 * 5. 记录下载 - 下载指定批次的操作数据
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query4.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 订单编号输入框 -->
      <el-input size="small" v-model="query4.uid" clearable placeholder="订单编号" style="width: 320px;"
                class="handle-input mr10"></el-input>
      <!-- 充值类型筛选（全部/取消限制激活/限制激活） -->
      <el-select size="small" style="width: 160px" v-model="query4.type" filterable clearable
                 placeholder="充值类型" class="handle-select mr10">
        <el-option v-for="item in rechargeList4" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 状态筛选（全部/成功/失败） -->
      <el-select size="small" style="width: 160px" v-model="query4.succeed" filterable clearable
                 placeholder="状态" class="handle-select mr10">
        <el-option v-for="item in succeedList2" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getactivateRecord">搜索
      </el-button>
      <!-- 添加返档按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus"
                 @click="handleAdd4">添加返档
      </el-button>
    </div>

    <!-- ========== 返档记录表格 ========== -->
    <el-table :data="tableData4" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 手机号 -->
      <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
      <!-- 操作原因 -->
      <el-table-column prop="operateMsg" label="操作原因" align="center"></el-table-column>
      <!-- 类型（限制激活=红色，取消限制激活=绿色） -->
      <el-table-column prop="type" label="类型" align="center">
        <template #default="scope">
          <span v-if="scope.row.type == '限制激活'" class="status_color2 bgred">{{ scope.row.type }}</span>
          <span v-if="scope.row.type == '取消限制激活'" class="status_color2 bggreen">{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <!-- 状态（失败时红色显示，悬浮提示错误原因） -->
      <el-table-column prop="status" label="状态" align="center">
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                      v-if="scope.row.status == false">
            <span style="color: #f56c6c;">失败</span>
          </el-tooltip>
          <span v-else>成功</span>
        </template>
      </el-table-column>
      <!-- 操作时间 -->
      <el-table-column prop="createdAt" label="时间" align="center" width="160"></el-table-column>
      <!-- 操作者 -->
      <el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
      <!-- 订单编号列（含下载和复制功能） -->
      <el-table-column prop="uid" label="订单编号" width="370" align="center">
        <template #default="scope">
          <span style="cursor: pointer;">
            <!-- 下载该批次数据 -->
            <i @click="getdownloadActivateRecord(scope.row.uid)" :class="[theme3]"
               class="el-icon-download" style="margin-right:10px;font-weight: 600;"></i>
            <!-- 点击复制订单编号 -->
            <span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 添加限制激活弹窗 ========== -->
    <!-- 支持手动输入和文件上传两种模式 -->
    <el-dialog title="添加限制激活" v-model="addVisible4" width="520px" @close="closeDialog4">
      <el-form label-width="120px" :model="addForm4" ref="addForm4">
        <!-- 选择模式 -->
        <el-form-item label="选择模式" prop="tab1">
          <el-radio-group v-model="tab1">
            <el-radio label="input">手动输入</el-radio>
            <el-radio label="fled">批量返档模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 类型选择：限制激活 或 取消限制激活 -->
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="addForm4.activate">
            <el-radio label="OFF">限制激活</el-radio>
            <el-radio label="ON">取消限制激活</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手动输入模式 -->
        <el-form-item label="手机号码" prop="phones" v-if="tab1 == 'input'">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm4.phones" auto-complete="off"
                    placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
        </el-form-item>
        <!-- 文件上传模式 -->
        <el-form-item label="上传文件" prop="" v-else>
          <el-upload ref="upload4" action="/api/dxt/batchActivate" :headers="token" :limit="1"
                     :on-success="uploadSuccess4" :auto-upload="false" :data="addForm4">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件
            </el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <!-- 操作原因 -->
        <el-form-item label="原因" prop="operateMsg">
          <el-input size="small" :rows="5" type="textarea" v-model="addForm4.operateMsg" auto-complete="off"
                    placeholder="请输入操作原因"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog4">取消</el-button>
          <!-- 手动输入模式提交 -->
          <el-button size="small" type="primary" :class="[theme]" v-if="tab1 == 'input'"
                     @click="getstopOrOpens4">确定
          </el-button>
          <!-- 文件上传模式提交 -->
          <el-button size="small" type="primary" :class="[theme]" v-else @click="submitUpload4">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 限制返档 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - activateRecord：查询返档记录
 * - downloadActivateRecord：下载返档记录数据
 * - getactivate：执行限制/取消限制激活操作
 */
import {
  activateRecord,
  downloadActivateRecord,
  getactivate,
} from '../../../api/dijia.js';

export default {
  name: 'DjActivationTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - theme3：辅助主题颜色类名（用于下载图标颜色）
   * - token：请求头信息，用于文件上传鉴权
   */
  props: {
    theme: { type: String, default: '' },
    theme3: { type: String, default: '' },
    token: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      query4: {                 // 查询参数
        type: '',               // 类型筛选
        phone: '',              // 手机号
        uid: '',                // 订单编号
        succeed: '',            // 状态筛选
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        userId: localStorage.getItem('user'),
      },
      tableData4: [],           // 返档记录列表
      pageTotal4: 0,            // 总条数
      rechargeList4: [          // 类型筛选选项
        { value: 0, label: '全部' },
        { value: 'ON', label: '取消限制激活' },
        { value: 'OFF', label: '限制激活' }
      ],
      succeedList2: [           // 状态筛选选项
        { value: 0, label: '全部' },
        { value: 1, label: '成功' },
        { value: -1, label: '失败' }
      ],

      // ========== 添加弹窗相关 ==========
      addVisible4: false,       // 弹窗是否显示
      addForm4: {               // 添加表单
        phones: '',             // 手机号（一行一个）
        userId: localStorage.getItem('user'),
        operateMsg: '',         // 操作原因
        activate: 'OFF',        // 操作类型（OFF=限制激活，ON=取消限制激活）
      },
      tab1: 'input',            // 当前模式
    };
  },

  /**
   * 组件创建时查询返档记录
   */
  created() {
    this.getactivateRecord();
  },

  methods: {
    /**
     * getactivateRecord - 查询返档记录列表
     */
    getactivateRecord() {
      this.loading = true;
      activateRecord(this.query4).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData4 = res.data.list;
          this.pageTotal4 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handleAdd4 - 打开添加返档弹窗
     */
    handleAdd4() {
      this.addVisible4 = true;
    },

    /**
     * getstopOrOpens4 - 手动输入模式提交限制/取消限制激活
     */
    getstopOrOpens4() {
      getactivate(this.addForm4).then(res => {
        if (res?.code === 200) {
          this.addVisible4 = false;
          this.$message.success(res.data);
          this.getactivateRecord();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * submitUpload4 - 文件上传模式提交
     */
    submitUpload4() {
      if (this.$refs.upload4.uploadFiles[0]) {
        this.loading = true;
        this.$refs.upload4.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },

    /**
     * closeDialog4 - 关闭弹窗并重置表单
     */
    closeDialog4() {
      this.addVisible4 = false;
      this.addForm4.phones = '';
      this.addForm4.operateMsg = '';
      this.addForm4.type = 'OPEN';
      this.tab1 = 'input';
    },

    /**
     * uploadSuccess4 - 文件上传成功回调
     * @param {Object} success - 上传接口返回结果
     */
    uploadSuccess4(success) {
      setTimeout(() => {
        this.$refs.upload4.clearFiles();
        this.addVisible4 = false;
      }, 2000);
      if (success?.code === 200) {
        this.$message.success('上传成功');
        this.getactivateRecord();
      } else {
        this.$message.error(success.message);
      }
    },

    /**
     * getdownloadActivateRecord - 下载指定批次的返档数据
     * @param {string} uid - 订单编号
     */
    getdownloadActivateRecord(uid) {
      this.$confirm('确定要下载该批次数据吗？', '提示', { type: 'warning' }).then(() => {
        let data = { uid: uid };
        downloadActivateRecord(data).then(res => {
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          });
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          let fileName = '限制返档记录' + uid + '.xlsx';
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        });
      }).catch(() => {});
    },

    /**
     * copyUrl - 复制文本到剪贴板
     * @param {string} item - 要复制的文本
     */
    copyUrl(item) {
      let cInput = document.createElement('input');
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$message.success('复制成功');
      document.body.removeChild(cInput);
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query4.pageIndex = val;
      this.getactivateRecord();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query4.pageSize = val;
      this.query4.pageIndex = 1;
      this.getactivateRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>